/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import Head from 'next/head';
import {useState} from 'react';
import styled from 'styled-components';
import {Columns, UpdatedDate, LegalWrapper, Wrapper} from '@/components/terms/styles';
export const meta = {
  title: 'Privacy Policy'
};
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h1: "h1",
    strong: "strong",
    em: "em",
    h2: "h2"
  }, _provideComponents(), props.components);
  return _jsxs(Wrapper, {
    children: [_jsx(_components.p, {
      children: "This click-through Enterprise Plan Master Services Agreement is intended for customers with 5 - 500 licenses only"
    }), _jsx(_components.h1, {
      children: "CLICK-THROUGH ENTERPRISE PLAN MASTER SERVICES AGREEMENT"
    }), _jsxs(_components.p, {
      children: ["THIS CLICK-THROUGH ENTERPRISE PLAN MASTER SERVICES AGREEMENT (THE “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "AGREEMENT"
        })
      }), "”) GOVERNS CUSTOMER’S ACQUISITION AND USE OF CALM’S ENTERPRISE PLAN SUBSCRIPTION SERVICES TO THE CALM MOBILE APPLICATION AND RELATED WEBSITE THAT PROVIDES A VARIETY OF MENTAL RESILIENCY CONTENT AND THE ASSOCIATED ADMIN CONSOLE (COLLECTIVELY, THE “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "SERVICES"
        })
      }), "”). CAPITALIZED TERMS HAVE THE DEFINITIONS SET FORTH HEREIN."]
    }), _jsxs(_components.p, {
      children: ["BY ACCEPTING THIS AGREEMENT, BY (1) CLICKING THE “I ACCEPT” BOX OR ANY OTHER BOX INDICATING ACCEPTANCE, (2) PURCHASING OR PLACING AN ORDER FOR THE SERVICES, OR (3) USING THE SERVICES ON A TRIAL OR PILOT BASIS, CUSTOMER AGREES TO THE TERMS AND CONDITIONS OF THIS AGREEMENT, INCLUDING THE PAYMENT AND SUBSCRIPTION RENEWAL PROVISIONS IN ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "SECTION 4.1"
      }), " AND ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "SECTION 7.1"
      }), ", THE LIMITED WARRANTY SET FORTH IN ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "SECTION 9.1"
      }), ", AND THE MANDATORY ARBITRATION PROVISION AND, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE CLASS ACTION WAIVER IN ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "SECTION 12.6"
      }), "."]
    }), _jsx(_components.p, {
      children: "IF THE INDIVIDUAL ACCEPTING THIS AGREEMENT IS ACCEPTING ON BEHALF OF A LEGAL ENTITY OR AN ORGANIZATION, SUCH INDIVIDUAL REPRESENTS THAT THEY HAVE THE AUTHORITY TO BIND SUCH ENTITY OR ORGANIZATION TO THESE TERMS AND CONDITIONS, IN WHICH CASE THE TERM “CUSTOMER” REFERS TO SUCH ENTITY OR ORGANIZATION. IF THE INDIVIDUAL ACCEPTING THIS AGREEMENT DOES NOT HAVE SUCH AUTHORITY, OR DOES NOT AGREE WITH THESE TERMS AND CONDITIONS, SUCH INDIVIDUAL MUST NOT ACCEPT THIS AGREEMENT AND MAY NOT USE THE SERVICES."
    }), _jsx(_components.p, {
      children: "The Services may not be accessed for purposes of monitoring their availability, performance or functionality, or for any other benchmarking or competitive purposes. Calm’s direct competitors are prohibited from accessing the Services, except with Calm’s prior written consent."
    }), _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "This Agreement was last updated on July 16, 2024."
      }), " It is effective between Customer and Calm as of the date of Customer’s accepting this Agreement (the “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Effective Date"
        })
      }), "”)."]
    }), _jsxs(_components.h2, {
      children: ["1. ", _jsx(_components.strong, {
        children: "DEFINITIONS"
      })]
    }), _jsxs(_components.p, {
      children: ["1.1 “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Admin Console"
        })
      }), "” means the online console(s) and tool(s) provided by Calm to Customer for administering the Services."]
    }), _jsxs(_components.p, {
      children: ["1.2 “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Administrators"
        })
      }), "” mean the Customer-designated technical personnel who administer the Services on Customer’s behalf."]
    }), _jsxs(_components.p, {
      children: ["1.3 “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Affiliate"
        })
      }), "” means an entity that controls, is controlled by, or is under common control with a Party. For the purposes of this definition, “", _jsx(_components.strong, {
        children: "control"
      }), "” and its cognates mean direct or indirect ownership of more than 50% of the voting interests of the applicable Party."]
    }), _jsxs(_components.p, {
      children: ["1.4 “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Calm"
        })
      }), "” means Calm.com, Inc., a Delaware corporation."]
    }), _jsxs(_components.p, {
      children: ["1.5 “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Claim"
        })
      }), "” means any claim, action, proceeding, or suit."]
    }), _jsxs(_components.p, {
      children: ["1.6 “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Customer"
        })
      }), "” means the legal entity or organization accepting this Agreement, or in the case of an individual accepting this Agreement on behalf of a legal entity or an organization, the legal entity or organization for which such individual is accepting this Agreement."]
    }), _jsxs(_components.p, {
      children: ["1.7 “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Customer Data"
        })
      }), "” means any identifying information (such as name, email address, employee ID number, or other identifying information designated by Customer) of an applicable User that is provided by Customer to Calm."]
    }), _jsxs(_components.p, {
      children: ["1.8 “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Law"
        })
      }), "” means all laws and regulations, including state and federal laws and regulations, binding orders, and ordinances, applicable to such Party in its performance of this Agreement, including privacy laws and regulations governing such Party and its data privacy practices."]
    }), _jsxs(_components.p, {
      children: ["1.9 “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Parties"
        })
      }), "” means collectively, Calm and Customer."]
    }), _jsxs(_components.p, {
      children: ["1.10 “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Party"
        })
      }), "” means either Calm or Customer."]
    }), _jsxs(_components.p, {
      children: ["1.11 “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "User"
        })
      }), "” means Customer’s personnel who are authorized to use the Services under Customer’s account, including employees, consultants, contractors, and agents of Customer."]
    }), _jsxs(_components.h2, {
      children: ["2. ", _jsx(_components.strong, {
        children: "CALM SERVICES"
      })]
    }), _jsxs(_components.p, {
      children: ["2.1 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Access to Services and Reports"
      }), ". Subject to Customer’s continuing compliance with its obligations set forth in this Agreement, and while this Agreement remains in effect: (a) Calm will provide access to the Services to: (i) each User authorized under this Agreement pursuant to (and subject to such User complying with) the then-current “Terms of Service” set forth on the website for the Services; and (ii) access to the Admin Console for the Administrator(s) to manage Customer’s use of the Services (and each User’s ability to access the Services, if applicable); and, (b) Customer may download and use, solely for its internal business purposes, any reports that are made available to Customer via the Service from time to time; in each case, in accordance with the provisions of this Agreement."]
    }), _jsxs(_components.p, {
      children: ["2.2 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Eligibility"
      }), ". Customer may designate a User as being eligible to access the Services by: (a) providing Calm with a monthly report (in a format acceptable to Calm) identifying such Users; (b) uploading the User information directly via the Admin Console; or (c) such other methods as agreed upon by the Parties. Customer will provide all notices and obtain all consents as required by Law to share the Customer Data with Calm for Calm’s processing in accordance with the Agreement. The maximum number of Users that can use the Services under this Agreement is identified at the time Customer purchases or places an order for the Services and thereafter, on Customer’s Admin Console (“", _jsx("strong", {
        children: _jsx("em", {
          children: "User Cap"
        })
      }), "”); provided that Calm may, in its sole discretion, update the User Cap at any time by posting the updated User Cap on Customer’s Admin Console. All Users must be affiliated with the legal entity or organization that is entering into this Agreement. Customer will only permit the number of Users designated as such by Customer (pursuant and subject to this ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Section 2.2"
      }), ") to use the Services."]
    }), _jsxs(_components.h2, {
      children: ["3. ", _jsx(_components.strong, {
        children: "CUSTOMER’S OBLIGATIONS"
      })]
    }), _jsxs(_components.p, {
      children: ["3.1 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Access Restrictions"
      }), ". Customer will not: (a) make the Services available to, or use the Services for the benefit of, anyone other than Users; (b) sublicense, resell, time share, or similarly exploit the Services; (c) reverse engineer, modify, adapt, or hack the Services, or otherwise attempt to gain unauthorized access to the Services or its related systems or networks; or (d) access the Services to build a competitive product or service."]
    }), _jsxs(_components.p, {
      children: ["3.2 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Admin Console"
      }), ". Customer may use the Admin Console to specify one or more Administrators who will have the right to access the Admin Console and to manage the Services. Customer will protect its Admin Console username and passwords (“", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Account Information"
        })
      }), "”) from unauthorized access or use and is responsible for all activities in the Services performed using its Account Information. Calm’s responsibilities do not extend to the internal management or administration of the Services for Customer."]
    }), _jsxs(_components.h2, {
      children: ["4. ", _jsx(_components.strong, {
        children: "COMPENSATION & PAYMENT"
      })]
    }), _jsxs(_components.p, {
      children: ["4.1 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Fees"
      }), ". By signing up for, purchasing or otherwise placing an order for the Services or upon increasing the number of Users that Customer can designate as being eligible to access the Services under this Agreement (subject to the User Cap), Customer’s chosen payment method will be charged for the Services fees or User fees (collectively, “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Fees"
        })
      }), "”). The Fees do not include taxes. Customer will pay all applicable taxes, levies, and duties associated with its purchase under this Agreement. At the beginning of each Renewal Subscription Term (defined below), the applicable Fees for the renewed Services and the number of Users that Customer has designated as being eligible to access the Services under this Agreement will be automatically charged to Customer’s chosen payment method, unless Customer terminates this Agreement prior to renewal. Calm will display or send a notice when Calm ultimately accepts Customer’s payment, and Calm’s acceptance will be complete at the time Calm displays or sends the formal acceptance notice. Payment must be received by Calm before Customer and Users can access and use the Services. Following the Initial Subscription Term (defined below), Calm may on an annual basis change the Fees charged."]
    }), _jsxs(_components.p, {
      children: ["4.2 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Payment"
      }), ". Payment obligations are non-cancelable, and Fees paid to Calm are non-refundable. All financial transactions conducted and executed for or related to the Services are made using one or more third-party payment processors that Calm may engage from time to time (each, a “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Payment Processor"
        })
      }), "”). All such transactions are governed by such Payment Processors’ respective terms of use and privacy policies, which Calm does not control. Calm encourages Customer to review each Payment Processors’ terms of service and privacy policies before submitting Customer’s payment information. Calm does not process or retain Customer’s credit card, debit card, or other payment information. This information is used solely for the purpose of allowing Customer to sign up for and access and use the Services. All billing information Customer provides to Payment Processor(s) must be truthful and accurate and Customer represents that Customer is authorized to use the payment method in the manner contemplated here. Customer hereby expressly authorizes Calm (via its Payment Processor(s)) to charge the payment method Customer provides for the Services and Fees. Customer’s selection of the “Accept”, “Proceed to Check Out”, “Place Your Order”, or similar button on the checkout page is Customer’s electronic signature and Customer agrees that: (a) this signature is the legal equivalent of Customer’s wet or manual signature; and (b) such transaction is equivalent to an in-person transaction where Customer’s payment method is physically present and processed. If Customer’s payment details change, Customer’s card or other payment method provider may provide Calm with updated payment details. Calm may use these new details or details from other payment methods on file in order to help prevent any interruption to Customer’s use of the Services. If Customer does not want Customer’s card or other payment method automatically updated, Customer can opt out of these services by contacting Customer’s financial institution. If Customer would like to use a different payment method or if there is a change in payment method, please update such method or information on Customer’s Admin Console."]
    }), _jsxs(_components.p, {
      children: ["4.3 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Late Payment"
      }), ". Any amount due under this Agreement that remains unpaid after its due date will bear interest from the date that such payment became delinquent until the date such amount is paid in full at the lower of 1.5% per month or the maximum rate permitted by Law, calculated from the date such amount was due until the date that payment is received. Customer will pay Calm such interest and all costs and expenses of collection (including attorneys’ fees) incurred by Calm for collecting any such past due amounts."]
    }), _jsxs(_components.h2, {
      children: ["5. ", _jsx(_components.strong, {
        children: "INTELLECTUAL PROPERTY; FEEDBACK"
      })]
    }), _jsxs(_components.p, {
      children: ["5.1 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Calm IP"
      }), ". As between Calm and Customer, Calm owns all right, title, and interest, including all intellectual property rights, in and to the Services, usage and other information collected through engagement with the Services (excluding any Customer Data), and any other information, reports, program, or marketing materials provided by Calm to Customer, including via the Services (collectively, “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Calm IP"
        })
      }), "”). All rights in the Calm IP not expressly granted to Customer in this Agreement are reserved by Calm."]
    }), _jsxs(_components.p, {
      children: ["5.2 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Feedback"
      }), ". Customer may (but is not obligated to) provide Calm with suggestions, ideas, enhancement requests, or other feedback (“", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Feedback"
        })
      }), "”). If Customer provides any such Feedback to Calm, Customer hereby grants Calm a nonexclusive, worldwide, perpetual, irrevocable, transferable, sublicensable, royalty-free, fully paid-up license to use and otherwise practice such Feedback."]
    }), _jsxs(_components.h2, {
      children: ["6. ", _jsx(_components.strong, {
        children: "DATA"
      })]
    }), _jsxs(_components.p, {
      children: ["6.1 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Customer Data"
      }), ". Customer owns all Customer Data. Customer hereby grants Calm and its Affiliates a nonexclusive, worldwide, royalty-free license during the Subscription Term (defined below) to use and access Customer Data and provide necessary access to third-party service providers acting on its behalf, such as Amazon Web Services, only to: (a) provide the Services and perform Calm’s obligations under this Agreement; and (b) to prevent or address service or technical problems, or at Customer’s request in connection with customer support matters."]
    }), _jsxs(_components.p, {
      children: ["6.2 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Protection of Customer Data"
      }), ". Calm will maintain reasonable administrative, physical, and technical safeguards to protect the Customer Data. Calm may update such security protections from time to time; provided, however, that Calm will not update or modify any security protections in a manner that materially decrease its security controls."]
    }), _jsxs(_components.h2, {
      children: ["7. ", _jsx(_components.strong, {
        children: "TERM AND TERMINATION"
      })]
    }), _jsxs(_components.p, {
      children: ["7.1 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Agreement Term"
      }), ". Unless terminated earlier as provided in the Agreement, this Agreement commences on the Effective Date and will remain in effect for twelve (12) months (“", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Initial Subscription Term"
        })
      }), "”). Unless a Party provides written notice of non-renewal at least thirty (30) days prior to any renewal of this Agreement, this Agreement and the Services will automatically renew for consecutive one-year terms (each, a “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Renewal Subscription Term"
        })
      }), "” and collectively, with the Initial Subscription Term, the “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Subscription Term"
        })
      }), "”). All User subscriptions under this Agreement will terminate when this Agreement terminates or expires."]
    }), _jsxs(_components.p, {
      children: ["7.2 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Termination for Cause"
      }), ". A Party may terminate this Agreement if the other Party materially breaches this Agreement, and such breach is not cured within thirty (30) days after the non-breaching Party has provided the breaching Party written notice thereof."]
    }), _jsxs(_components.p, {
      children: ["7.3 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Effects of Termination"
      }), ". Upon the termination or expiration of this Agreement, the Services and all of Customer’s and its Users’ rights under this Agreement will immediately terminate. Calm will destroy or anonymize all Customer Data, in the manner and on the schedule as required by Law, and in accordance with Calm’s then-current data deletion practices. Termination or expiration will not relieve either Party of obligations incurred prior to the effective date of the termination or expiration. The following Sections survive the expiration or termination of this Agreement: 1, 4 (with respect to amounts accrued prior to expiration or termination), 5, 6.1, 7.3, 8, 9.3, 9.4, 10, 11, and 12."]
    }), _jsxs(_components.p, {
      children: ["7.4 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Suspension"
      }), ". Calm may suspend access to all or any part of the Services: (a) with thirty (30) days’ written notice, if Customer fails to make any payments when due; and Fees will continue to accrue during any such suspension; or (b) if Customer breaches this Agreement, and such breach is not cured within thirty (30) days after Calm has provided Customer written notice thereof."]
    }), _jsxs(_components.h2, {
      children: ["8. ", _jsx(_components.strong, {
        children: "CONFIDENTIAL INFORMATION"
      })]
    }), _jsxs(_components.p, {
      children: ["8.1 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Definition of Confidential Information"
      }), ". As used herein, “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Confidential Information"
        })
      }), "” means any nonpublic or proprietary information disclosed by a Party (“", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Discloser"
        })
      }), "”) to the other Party (“", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Recipient"
        })
      }), "”), whether orally or in writing, that: (a) is marked or declared “Confidential” or “Proprietary” or in some other manner to indicate its confidential nature; or (b) based upon the facts and circumstances of the disclosure, information that a reasonable person would consider confidential. For clarity, Customer Data is the Confidential Information of Customer, and the terms of this Agreement, and all pricing information under this Agreement, is Confidential Information of Calm. Confidential Information does not include any information that: (i) was publicly available prior to the time of disclosure by the Discloser; (ii) becomes publicly available after disclosure by the Discloser to the Recipient through no action or inaction of the Recipient; (iii) is already in the lawful possession of the Recipient at the time of disclosure; (iv) is obtained by the Recipient from a third party without a breach of such third party’s obligations of confidentiality; or (v) is independently developed by the Recipient without use of or reference to the Discloser’s Confidential Information."]
    }), _jsxs(_components.p, {
      children: ["8.2 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Protection of Confidential Information"
      }), ". Recipient will: (a) use the same degree of care that it uses to protect the confidentiality of its own confidential information of like kind (but in no event less than reasonable care); (b) not use any Confidential Information for any purpose outside the scope of this Agreement; and (c) only disclose Confidential Information of the Discloser to those of its (and solely with respect to Calm, its Affiliates’) employees, contractors, and agents (“", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Representative(s)"
        })
      }), "”) who are bound in writing by confidentiality obligations at least as protective as this Agreement andneed such access for purposes consistent with this Agreement. If any Representative discloses or uses Confidential Information other than as authorized in this Agreement, Recipient will be liable to Discloser for such disclosure or use to the same extent that Recipient would have been liable had Recipient performed such unauthorized disclosure or use."]
    }), _jsxs(_components.p, {
      children: ["8.3 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Compelled Access or Disclosure"
      }), ". Notwithstanding any language to the contrary, Recipient may disclose Confidential Information if it is compelled by Law to do so, if Recipient gives the Discloser prior notice of such compelled disclosure (to the extent legally permitted) and provides reasonable assistance, at the Discloser’s cost, if Discloser wishes to contest such disclosure."]
    }), _jsxs(_components.h2, {
      children: ["9. ", _jsx(_components.strong, {
        children: "WARRANTY; DISCLAIMER"
      })]
    }), _jsxs(_components.p, {
      children: ["9.1 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Warranty"
      }), ". Each Party represents and warrants that: (a) it has full power and authority to enter into this Agreement; and (b) the person signing this Agreement on its behalf has the authority to do so."]
    }), _jsxs(_components.p, {
      children: ["9.2 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Compliance"
      }), ". In the performance of this Agreement, each Party will comply with the Law applicable to it."]
    }), _jsxs(_components.p, {
      children: ["9.3 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Disclaimer"
      }), ". EXCEPT AS EXPRESSLY PROVIDED IN THIS AGREEMENT, THE SERVICES AND ANY OTHER INFORMATION (INCLUDING THE REPORTS) ARE PROVIDED BY CALM “AS IS” AND ON AN “AS AVAILABLE” BASIS WITHOUT WARRANTY OF ANY KIND; AND, CALM EXPRESSLY DISCLAIMS ALL OTHER WARRANTIES, EXPRESS, IMPLIED (EITHER IN FACT OR BY OPERATION OF LAW), OR STATUTORY, AS TO ANY MATTER WHATSOEVER (INCLUDING WITH RESPECT TO THE USE OF, OR THE RESULTS FROM THE USE OF, THE SERVICES), INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, TITLE, NON-INFRINGEMENT, FITNESS FOR A PARTICULAR PURPOSE OR USE, WARRANTIES IMPLIED FROM A COURSE OF DEALING OR COURSE OF PERFORMANCE OR USAGE OF TRADE, OR THAT THE SERVICES AND ANY OTHER INFORMATION PROVIDED BY CALM ARE OR WILL BE ERROR-FREE OR UNINTERRUPTED. CUSTOMER HAS NO RIGHT TO MAKE OR PASS ON ANY REPRESENTATION OR WARRANTY ON BEHALF OF CALM TO ANY PERSON."]
    }), _jsxs(_components.p, {
      children: ["9.4 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "No Medical Use"
      }), ". THE SERVICES DO NOT MAKE A MEDICAL DIAGNOSIS, PROVIDE MEDICAL CARE OR CLINICAL TREATMENT, OR PRESCRIBE MEDICATIONS AND SHOULD IN NO WAY BE CONSIDERED A REPLACEMENT FOR MEDICAL ADVICE OR ACTION IN ORDER TO CURE, TREAT, OR PREVENT DISEASES OF ANY NATURE. CUSTOMER WILL NOT MAKE STATEMENTS THAT THE SERVICES ARE MEANT TO BE USED IN THE TREATMENT OR MANAGEMENT OF ANY DISEASES OR CONDITIONS."]
    }), _jsxs(_components.h2, {
      children: ["10. ", _jsx(_components.strong, {
        children: "LIMITATION OF LIABILITY"
      })]
    }), _jsxs(_components.p, {
      children: ["10.1 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Limitation of Liability"
      }), ". EXCEPT AS SET FORTH IN ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "SECTION 10.2"
      }), ", TO THE GREATEST EXTENT PERMITTED BY LAW, EVEN IF SUCH DAMAGES COULD HAVE BEEN FORESEEN OR IF A PARTY HAS BEEN APPRISED OF THE POSSIBILITY OF SUCH DAMAGES, AND REGARDLESS OF WHETHER SUCH DAMAGES ARE ARISING IN CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, BREACH OF ANY STATUTORY DUTY, OR OTHERWISE: (A) NEITHER PARTY WILL BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT, PUNITIVE, OR CONSEQUENTIAL DAMAGES ARISING OUT OF OR PERTAINING TO THIS AGREEMENT SUFFERED BY CUSTOMER OR OTHERS (INCLUDING ANY LOST PROFITS, LOST REVENUE OR LOSS OF GOODWILL); AND (B) EACH PARTY’S TOTAL AND CUMULATIVE LIABILITY FOR ALL CLAIMS OF ANY NATURE ARISING OUT OF OR PERTAINING TO THIS AGREEMENT WILL NOT EXCEED THE TOTAL FEES PAID OR PAYABLE BY CUSTOMER TO CALM IN THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING THE OCCURRENCE OF THE FIRST EVENT GIVING RISE TO A CLAIM UNDER THIS AGREEMENT."]
    }), _jsxs(_components.p, {
      children: ["10.2 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Exceptions"
      }), ". THE LIMITATIONS SET FORTH IN ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "SECTION 10.1"
      }), " DO NOT APPLY TO: (A) EITHER PARTY’S INDEMNIFICATION OBLIGATIONS UNDER ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "SECTION 11"
      }), "; OR (B) DAMAGES ARISING OUT OF EITHER PARTY’S GROSS NEGLIGENCE OR WILLFUL MISCONDUCT OR CUSTOMER’S UNAUTHORIZED USE OF CALM IP OR CUSTOMER’S FAILURE TO PAY ANY AMOUNTS DUE UNDER THIS AGREEMENT."]
    }), _jsxs(_components.p, {
      children: ["10.3 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Independent Allocations of Risk"
      }), ". EACH PROVISION OF THIS AGREEMENT THAT PROVIDES FOR A LIMITATION OF LIABILITY, DISCLAIMER OF WARRANTIES, OR EXCLUSION OF DAMAGES IS TO ALLOCATE THE RISKS OF THIS AGREEMENT BETWEEN THE PARTIES. THIS ALLOCATION IS REFLECTED IN THE AGREED UPON COMPENSATION AND IS AN ESSENTIAL ELEMENT OF THE BASIS OF THE BARGAIN BETWEEN THE PARTIES. EACH OF THESE PROVISIONS WILL APPLY EVEN IF THE WARRANTIES IN THIS AGREEMENT HAVE FAILED OF THEIR ESSENTIAL PURPOSE."]
    }), _jsxs(_components.h2, {
      children: ["11. ", _jsx(_components.strong, {
        children: "INDEMNIFICATION"
      })]
    }), _jsxs(_components.p, {
      children: ["11.1 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Calm Indemnification"
      }), ". Calm will defend Customer and its directors, officers, and employees against any third-party Claim and will pay for the resulting costs and damages finally awarded against Customer to such third party by a court of competent jurisdiction or agreed to in settlement by Calm (such agreement not to be unreasonably, withheld, conditioned, or delayed), to the extent arising from the actual or alleged infringement of such third party’s intellectual property rights by the Services. Calm will have no indemnification obligations arising from this ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Section 11.1"
      }), ", to the extent such Claim arises from: (a) the use or combination of the Services with any hardware, software, products, processes, data, or other materials not provided by Calm, including Customer’s own systems and data; (b) modification or alteration of the Services by anyone other than Calm; or, (c) Customer’s or any User’s misuse of the Services or use of the Services in excess of the rights granted in the Agreement."]
    }), _jsxs(_components.p, {
      children: ["11.2 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Customer Indemnification"
      }), ". Customer will defend Calm and its directors, officers, and employees against any third-party Claim and will pay for the resulting costs and damages finally awarded against Calm to such third party by a court of competent jurisdiction or agreed to in settlement by Customer (such agreement not to be unreasonably, withheld, conditioned, or delayed), arising from any allegation that: (a) the Customer Data or other content or information provided by Customer to Calm infringes, misappropriates, or violates the rights of a third party; or (b) Customer’s use of the Services in violation of Law."]
    }), _jsxs(_components.p, {
      children: ["11.3 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Indemnity Obligations"
      }), ". The indemnifying Party’s (the “", _jsx("strong", {
        children: _jsx("em", {
          children: "Indemnitor"
        })
      }), "”) obligations under this ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Section 11"
      }), " are conditioned upon the person(s) seeking indemnification under this ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Section 11"
      }), " (the “", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "Indemnitee(s)"
        })
      }), "”): (a) promptly notifying the Indemnitor in writing of the Claim (so as to avoid prejudicing the Indemnitor); (b) granting the Indemnitor sole control of the defense and settlement of the Claim provided that any such settlement does not bind any Indemnitee to pay any monetary amounts or admit to any wrongdoing; and, (c) providing the Indemnitor, at the Indemnitor’s expense, with all assistance, information, and authority reasonably required for the defense and settlement of the Claim."]
    }), _jsxs(_components.h2, {
      children: ["12. ", _jsx(_components.strong, {
        children: "GENERAL"
      })]
    }), _jsxs(_components.p, {
      children: ["12.1 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Independent Contractors"
      }), ". The Parties are independent contractors; and nothing contained in this Agreement gives either Party the power to act as an agent of the other or to direct or control the day-to-day activities of the other."]
    }), _jsxs(_components.p, {
      children: ["12.2 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Assignment"
      }), ". Customer may not assign its rights or delegate its obligations under this Agreement, by operation of law or otherwise, without the prior written consent of Calm. Any amalgamation or merger of Customer with any third party, or the purchase of all or substantially all of the assets or equity of Customer, will be deemed an assignment requiring consent. Any attempted transfer in violation of this Section is void. Calm may, without the prior written consent of Customer, assign or delegate all or any part of its obligations under this Agreement."]
    }), _jsxs(_components.p, {
      children: ["12.3 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Notices"
      }), ". Any notice must be in writing and will be effective upon delivery as follows: (a) if to Customer, when (i) delivered via registered mail, return receipt requested, or overnight delivery service to the address specified on Customer’s Admin Console; or (ii) when sent via email to the email address specified on Customer’s Admin Console or otherwise on record for Customer; and (b) if to Calm, when sent via email to notices@calm.com, with a duplicate copy sent via registered mail, return receipt requested, to the following address: Calm.com, Inc., Attn: Legal, 555 Bryant Street, Suite 262, Palo Alto, CA 94301. Either Party may change its address for receipt of notices by providing notice to the other Party in accordance with this Section."]
    }), _jsxs(_components.p, {
      children: ["12.4 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Force Majeure"
      }), ". Neither Party will be liable to the other Party for the nonperformance of any obligation under this Agreement (other than any payment obligation) arising from any cause beyond such Party’s or its suppliers’ reasonable control, regardless of whether such cause is foreseeable, including any: (a) act of God; (b) flood, fire, explosion, earthquake, or natural disaster; (c) act of terrorism, war, revolution, invasion, riot, or other civil or military disturbances or acts of public enemies; (d) act, regulation, order, or Law of any government, civil or military authority, or any injunction of any nature; (e) embargo, blockade, tariff, or other trade restriction in effect on or after the Effective Date; (f) national or regional emergency; (g) epidemic, pandemic, or other contagion, including COVID-19; (h) strike, lockout, labor dispute, stoppage or slowdown, or other industrial disturbance; (i) casualty or accident; (j) denial of service attacks and other malicious conduct; or (k) inability to procure, or any interruption, loss, malfunction, or shortage of, any supplies, services, products, equipment, transportation, utilities, communications, or computer software, hardware, or services."]
    }), _jsxs(_components.p, {
      children: ["12.5 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Governing Law"
      }), ". This Agreement and all proceedings arising hereunder will be governed by and construed in accordance with the laws of the state of California without reference to its principles of conflicts of law. The Parties expressly exclude the application of the U.N. Convention on Contracts for the International Sale of Goods (1980) to this Agreement."]
    }), _jsxs(_components.p, {
      children: ["12.6 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Disputes"
      }), ". Any dispute arising between the Parties out of or in connection with this Agreement will be finally resolved by arbitration conducted by one arbitrator (who is a licensed attorney) in San Francisco County, California in accordance with the Commercial Arbitration Rules of the American Arbitration Association. The arbitrator’s award will be final and binding and may be entered in any court having jurisdiction thereof. Each Party will bear its own costs and attorneys’ fees and will share equally in the fees and expenses of the arbitrator. The arbitration will be conducted in English, the governing language of this Agreement. Nothing contained herein will prevent a Party from obtaining injunctive relief from any court of competent jurisdiction. NO CLASS OR REPRESENTATIVE ACTIONS OR ARBITRATIONS ARE ALLOWED UNDER THIS AGREEMENT. CUSTOMER AND COMPANY HEREBY AGREE THAT ARBITRATION WILL BE SOLELY ON AN INDIVIDUAL BASIS AND NOT AS A CLASS ARBITRATION, CLASS ACTION, OR ANY OTHER KIND OF REPRESENTATIVE PROCEEDING. COMPANY AND CUSTOMER HEREBY WAIVE THE RIGHT TO TRIAL BY A JURY."]
    }), _jsxs(_components.p, {
      children: ["12.7 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Severability"
      }), ". Each provision contained in this Agreement constitutes a separate and distinct provision severable from all other provisions. If any provision (or any part thereof) is unenforceable under or prohibited by any present or future Law, then such provision (or part thereof) will be amended, and is hereby amended, so as to be in compliance with such Law, while preserving to the maximum extent possible the intent of the original provision. Any provision (or part thereof) that cannot be so amended will be severed from this Agreement; and all the remaining provisions of this Agreement will remain unimpaired."]
    }), _jsxs(_components.p, {
      children: ["12.8 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "No Third-Party Beneficiaries"
      }), ". There are no third-party beneficiaries to this Agreement."]
    }), _jsxs(_components.p, {
      children: ["12.9 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Publicity"
      }), ". Neither Party will issue any press releases or make any social media posts referencing the other Party except with the prior written permission of the other Party or as required by Law. Without limiting the foregoing, Calm may use Customer’s name, logo, or marks for the purpose of marketing the Services without prior approval."]
    }), _jsxs(_components.p, {
      children: ["12.10 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "U.S. Government Customers"
      }), ". The Services use a technology platform that is a “commercial item,” as that term is defined in 48 C.F.R. 2.101, consisting of “commercial computer software” and “commercial computer software documentation,” as such terms are used in 48 C.F.R. 12.212. Consistent with 48 C.F.R. 12.212 and 48 C.F.R. 227.7202-1 through 227.7202-4, all U.S. Government customers and/or users acquire such software and documentation with only those rights set forth herein. If a government agency has a need for rights not conveyed under these terms, it must negotiate with Calm to determine if there are acceptable terms for transferring such rights, and a mutually acceptable written addendum specifically conveying such rights must be included in any applicable contract or agreement."]
    }), _jsxs(_components.p, {
      children: ["12.11 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Amendment and Waiver"
      }), ". No modification, amendment, or waiver of any provision of this Agreement will be effective unless it exists in writing and is signed by the Party against whom the modification, amendment, or waiver is to be asserted. The delay or failure of a Party at any time to require performance of any obligations of the other Party will not be deemed to be a waiver and will not affect its right to enforce any provision of this Agreement at a subsequent time. One waiver will not imply or be construed to be a waiver of any future breach."]
    }), _jsxs(_components.p, {
      children: ["12.12 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Entire Agreement"
      }), ". This Agreement (and any confirmation or receipt of Customer’s purchase or placement of any order for the Services, in each case provided by Calm, if any) constitutes the complete and exclusive statement of all mutual understandings between Calm and Customer with respect to the subject matter hereof, superseding all prior or contemporaneous proposals, communications, and understandings, oral or written. Other than a confirmation or receipt provided by Calm, nothing contained in any purchase order, acknowledgment, confirmation or invoice will in any way modify or add to the terms or conditions of this Agreement and the Parties hereby expressly reject any such terms and conditions contained in any of the foregoing."]
    }), _jsxs(_components.p, {
      children: ["12.13 ", _jsx("span", {
        style: {
          textDecoration: 'underline'
        },
        children: "Interpretation"
      }), ". In this Agreement: (a) the headings are for convenience only and will not affect the meaning or interpretation of this Agreement; (b) the words “herein,” “hereunder,” “hereby,” and similar words refer to this Agreement as a whole (and not to the particular sentence, paragraph, or Section where they appear); (c) terms used in the plural include the singular, and vice versa, unless the context clearly requires otherwise; (d) “or” is used in the sense of “and/or”; (e) “any” is used in the sense of “any or all”; and (f) the words “include,” “includes,” or “including” are to be construed as if they are immediately followed by the words “without limitation.” If an ambiguity or question of intent or interpretation arises, then this Agreement will be construed as if drafted jointly by the Parties and no presumption or burden of proof will arise favoring or disfavoring any Party by virtue of the authorship of any of the terms hereof or thereof."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
